export default __webpack_public_path__ + "static/media/Parallax-HUD-Pop-Up (Process).929828a1.jpg";